import CompanyTab from '../Components/CompanyTab'
import AdminProfileEdit from '@/modules/AdminProfile/AdminProfileEdit'

const Company = () => (
  <>
    {/* <CompanyTab /> */}
    <AdminProfileEdit />
  </>
)

export default Company
